import { useState, useCallback } from "react";
import { usePermissions } from "../../../hooks/usePermissions";
import { useDebounce } from "../../../hooks/useDebounce";

export function useAccessManagementPermissions() {
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 600);

  const {
    permissions,
    loading,
    error,
    page,
    pageSize,
    totalCount,
    totalPages,
    setPage,
    setPageSize,
    refetch,
  } = usePermissions(debouncedSearch);

  const handleSearchChange = useCallback((value: string) => {
    setSearch(value);
    // Reset to first page when changing search
    setPage(1);
  }, [setPage]);

  const handlePageSizeChange = useCallback(
    (size: number) => {
      setPageSize(size);
      setPage(1);
    },
    [setPage, setPageSize]
  );

  return {
    functions: {
      handleSearchChange,
      handlePageChange: setPage,
      handlePageSizeChange,
      refetch,
    },
    values: {
      permissions,
      search,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
    loading: {
      isPageLoading: loading,
    },
    error,
    setters: {
      setSearch,
      setPage,
      setPageSize,
    },
  };
}

